import styled from 'styled-components'

export const AditionalInfoContainer = styled.div`
  max-width: calc(80% - 6px);
  margin-bottom: 1.5rem;
  margin-top: 10px;

  @media (max-width: 1024px) {
    max-width: 100%;
  }
`
